// SPDX-License-Identifier: Apache-2.0

// /dev — landing page listing the kernel diagnostic benches. Reachable via
// the discreet footer link in App.tsx. These pages used to be primary routes
// (`/notes`, `/search`, `/orbit`) but were demoted to /dev/* on 2026-04-26
// because they're WGSL kernel benches, not the product.

import { A } from "@solidjs/router";

export default function DevIndex() {
  return (
    <div style={{ padding: "48px 24px 96px", "max-width": "880px", margin: "0 auto" }}>
      <p class="kicker">internal · diagnostics</p>
      <h1 style={{ "font-size": "42px", "margin-top": "8px" }}>Dev Tools</h1>
      <p style={{ "margin-top": "16px", "font-size": "15px", color: "#9a9ab0" }}>
        Kernel diagnostic pages — internal use. The actual product is the vault on
        <code style={{ margin: "0 4px" }}>/</code>; these pages exercise the WGSL
        kernels behind the scenes for benchmarking and regression testing.
      </p>

      <div class="dev-card-grid">
        <A class="dev-card" href="/dev/notes">
          <div class="label">/dev/notes</div>
          <div class="desc">
            cosineSim + topK bench — int8 cosine similarity then per-workgroup bitonic top-K.
          </div>
        </A>
        <A class="dev-card" href="/dev/search">
          <div class="label">/dev/search</div>
          <div class="desc">
            tfidfSpMV + kHopBFS bench — sparse posting SpMV and frontier-based BFS.
          </div>
        </A>
        <A class="dev-card" href="/dev/orbit">
          <div class="label">/dev/orbit</div>
          <div class="desc">
            forceLayoutStep visualization — N-body force sim driving an InstancedMesh.
          </div>
        </A>
      </div>

      <p style={{ "margin-top": "48px", "font-size": "12px", color: "#6a6a80" }}>
        These pages exercise the WGSL kernels behind the scenes of the main vault.
        Useful for benchmarking and regression testing.
      </p>
    </div>
  );
}
